import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LrfService from '../../../services/lrf'
import InfiniteScroll from '../../auth/utils/infiniteScroll';
import Lrf from './lrf';


const Listarlrfs = () => {

    async function fetchLrfs() {
        await seraQueAcabou();
        const response = await LrfService.tipo({ limit: true, cod_lrf: cod, bimestre: "RREO" });
        if (response.data.length >= 1) {
            let count = Math.floor(numLrf / 20) + 1
            for (let i = 1; i < count; i++) {
                setLrfs([...lrfs, ...response.data])
                setCod(response.data[response.data.length - 1]["cod_lrf"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setLrfs([])
            setVazio(true)
        }
    }

    const [lrfs, setLrfs] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [cod, setCod] = useState(null);
    const [numLrf, setNumLrf] = useState(null);
    const [aindaTem, setAindaTem] = useState();



    async function fetchLrfsIn() {
        await pegaNumLrf();
        const response = await LrfService.tipo({bimestre: "RREO", limit: true});
        if (response.data.length >= 1) {
            setLrfs(response.data)
            setVazio(false)
            setCod(response.data[response.data.length - 1]["cod_lrf"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setLrfs([])
            setVazio(true)
        }
    }

    async function pegaNumLrf() {
        const response = await LrfService.numLrf({ todas: false, bimestre: "RREO" })
        setNumLrf(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (lrfs.length >= numLrf) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }


    useEffect(() => {
        fetchLrfsIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setLrfs={setLrfs}
                    setVazio={setVazio}
                    setAindaTem={setAindaTem}
                    fetchLrfsIn={fetchLrfsIn}
                    lrfs={lrfs}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {lrfs.map((lrf, index) =>
                            <Lrf
                                lrf={lrf}
                                key={index}
                            />
                        )}
                    </Row>
                    {aindaTem ?
                        <Fragment>
                            <p>Carregando mais relatórios...</p>
                            <InfiniteScroll Listar={fetchLrfs} />
                        </Fragment>
                        : <p>Todos os relatórios já foram exibidos :)</p>}
                </Fragment>}
        </Fragment>

    )
}

export default Listarlrfs;